// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__127sV","location":"Header_location__2y5XS"};